import { ApiError } from './api-error';

export class PaymentIntentCreateBlockedError extends ApiError {
  constructor() {
    super(409, 'Payment blocked', 'DP-001');
    this.name = 'PaymentIntentCreateBlockedError';
  }
}
